import LayoutContent from '../../components/layouts/content2';
import React, { useState, useEffect } from 'react';

import { useTranslation } from 'react-i18next';
import { getData } from '../../helpers/indexedDbHelper';
import SpecialsScreen from './specials';
import { useRefresh } from '../../hooks/useRefresh';
import ListProducts from './ListProducts';
import CoctailScreen from './coctail.js';
import BeersScreen from './beers.js';
import MargaritasScreen from './margaritas.js';
import WinesScreen from './wines.js';
import SpiritsScreen from './spirits.js';
import BottlesScreen from './bottles.js';

function Index({ setShowHappy }) {
  const { i18n } = useTranslation();
  const langEng = i18n.language === 'en' ?? false;

  const { change } = useRefresh();

  const [menus, setMenus] = useState([]);

  const [showSpecials, setShowSpecials] = useState(false);
  const [showCoctatik, setshowCoctatik] = useState(false);
  const [showBeers, setshowBeers] = useState(false);
  const [showBottles, setshowBottles] = useState(false);
  const [showMargaritas, setshowMargaritas] = useState(false);
  const [showSpirits, setShowSpirits] = useState(false);
  const [showWines, setshowWines] = useState(false);
  const [showListProduct, setShowListProduct] = useState(false);
  const [dishs, setdishs] = useState(false);
  const [beers, setbeers] = useState(false);
  const [coladas, setcoladas] = useState(false);
  const [martinis, setmartinis] = useState(false);
  const [sangria, setsangria] = useState(false);
  const [noalcol, setnoalcol] = useState(false);
  const [mojitos, setmojitos] = useState(false);
  const [margaritas, setmargaritas] = useState(false);
  const [dataCocktail, setdataCocktail] = useState(false);

  useEffect(() => {
    getData('menu').then((items) => {
      const data = items.value.data;

      setMenus(data);
    });
  }, [change]);

  useEffect(() => {
    menus.map((item) => {
      if (item.id === 393) {
        setbeers(item);
      }
      if (item.id === 390) {
        setcoladas(item);
      }
      if (item.id === 391) {
        setmartinis(item);
      }
      if (item.id === 392) {
        setsangria(item);
      }
      if (item.id === 417) {
        setnoalcol(item);
      }
      if (item.id === 614) {
        setmojitos(item);
      }
      if (item.id === 615) {
        setmargaritas(item);
      }
      if (item.id === 590) {
        setdataCocktail(item);
      }
    });
  }, [menus]);

  return (
    <div
      style={{
        position: 'absolute',
        top: 4,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: 9999,
      }}
    >
      <LayoutContent
        showBack={true}
        setShowSpecials={setShowSpecials}
        setShowListProduct={setShowHappy}
      >
        <div style={{ padding: '0 20px' }}>
          <div
            style={{
              width: '70%',
              marginTop: 20,
              marginBottom: 20,
              margin: '0 auto',
              border: '5px solid #ED3E08',
              display: 'flex',
              alignSelf: 'center',
              justifyContent: 'center',
              alignItems: 'center',
              paddingBlock: 5,
              position: 'relative',
            }}
          >
            <div>
              <p
                style={{
                  fontFamily: 'Watchtower',
                  fontSize: 60,
                  color: '#ED3E08',
                  margin: 0,
                }}
              >
                NON ALCOHOLIC DRINKS
              </p>
            </div>
            <img
              src={require('./assets/OBJECTS2.png')}
              style={{
                width: 60,
                height: 60,
                objectFit: 'contain',
                position: 'absolute',
                right: -80,
              }}
            />
          </div>

          <br />
          <br />
          <img
            src={require('./assets/nonalcohol.png')}
            style={{
              width: '100%',
              height: 600,
              objectFit: 'contain',
            }}
          />
        </div>

        {showListProduct && (
          <ListProducts dishs={dishs} setShowListProduct={setShowListProduct} />
        )}

        {showCoctatik && <CoctailScreen setShowHappy={setshowCoctatik} />}
        {showBeers && <BeersScreen setShowHappy={setshowBeers} />}
        {showMargaritas && (
          <MargaritasScreen setShowHappy={setshowMargaritas} />
        )}
        {showWines && <WinesScreen setShowHappy={setshowWines} />}
        {showSpirits && <SpiritsScreen setShowHappy={setShowSpirits} />}
        {showBottles && <BottlesScreen setShowHappy={setshowBottles} />}

        {showSpecials && (
          <SpecialsScreen
            setShowListProduct={setShowSpecials}
            setShowHappy={setShowHappy}
          />
        )}
      </LayoutContent>
    </div>
  );
}
export default Index;
